export default __webpack_public_path__ + "static/media/two-steps-verification-illustration.4cf04f2a.svg";